<template>
  <div class="my-biography">
    <PublicProfileHeader :content-type="content_type" :active-tab="2" />
    <v-container>
      <v-row>
        <v-col
          class="text-center"
          cols="12"
        >
          <div class="tw-toggle">
            <input
              id="rdo-personal"
              type="radio"
              name="toggle"
              value="false"
              :checked="content_type === 0"
              @click="checkContentType(0)"
            />
            <label
              for="rdo-personal"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccount}"
                class="mx-auto"
              >
                {{ mdiAccount }}
              </v-icon>
            </label>
            <input
              id="rdo-both"
              type="radio"
              name="toggle"
              value="-1"
              :checked="content_type === -1"
              @click="checkContentType(-1)"
            />
            <label
              for="rdo-both"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccountMultiple}"
                class="mx-auto"
              >
                {{ mdiAccountMultiple }}
              </v-icon>
            </label>
            <input
              id="rdo-professional"
              type="radio"
              name="toggle"
              value="true"
              :checked="content_type === 1"
              @click="checkContentType(1)"
            />
            <label
              for="rdo-professional"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccountTie}"
                class="mx-auto"
              >
                {{ mdiAccountTie }}
              </v-icon>
            </label>
            <span></span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <div class="d-flex justify-center wrapper-menu">
          <!-- ### Menu Mobile ### -->
          <template v-if="$vuetify.breakpoint.mdAndDown">
            <v-list class="mobile--menu-list">
              <v-list-group
                :value="false"
              >
                <template v-slot:activator>
                  <v-list-item-title>Categories</v-list-item-title>
                </template>

                <template v-if="!content_type || content_type === -1">
                  <div
                    v-for="(item, i) in categories"
                    :key="`system-${i}`"
                  >
                    <v-list-item
                      v-if="!item.children"
                      class="single_item"
                      link
                      @click="searchCategory(item.id, 1)"
                    >
                      <span>-</span> {{ item.name }}
                    </v-list-item>
                    <div v-else>
                      <v-list-group
                        :value="false"
                        no-action
                        sub-group
                      >
                        <template v-slot:activator>
                          <v-list-item-title @click="searchCategory(item.id, 1)">
                            {{ item.name }}
                          </v-list-item-title>
                        </template>
                        <div
                          v-for="(itemL1) in item.children"
                          :key="`system-L-${itemL1.id}`"
                        >
                          <v-list-item
                            v-if="!itemL1.children"
                            class="single_item"
                            link
                            @click="searchCategory(itemL1.id, 1)"
                          >
                            <span>-</span> {{ itemL1.name }}
                          </v-list-item>
                          <v-list-group
                            v-else
                            :value="false"
                            no-action
                            sub-group
                          >
                            <template v-slot:activator>
                              <v-list-item-title @click="searchCategory(itemL1.id, 1)">
                                {{ itemL1.name }}
                              </v-list-item-title>
                            </template>
                            <v-list-item
                              v-for="(itemL2, index) in itemL1.children"
                              :key="`system-L2-${index}`"
                              class="single_item"
                              link
                              @click="searchCategory(itemL2.id, 1)"
                            >
                              <span>-</span> {{ itemL2.name }}
                            </v-list-item>
                            <v-divider></v-divider>
                          </v-list-group>
                        </div>
                        <v-divider></v-divider>
                      </v-list-group>
                    </div>
                  </div>
                </template>

                <template v-if="content_type || content_type === -1">
                  <div
                    v-for="(item, i) in professionalCategories"
                    :key="`prof-${i}`"
                  >
                    <v-list-item
                      v-if="!item.children"
                      class="single_item"
                      link
                      @click="searchCategory(item.id, 1)"
                    >
                      <span>-</span> {{ item.name }}
                    </v-list-item>
                    <div v-else>
                      <v-list-group
                        :value="false"
                        no-action
                        sub-group
                      >
                        <template v-slot:activator>
                          <v-list-item-title @click="searchCategory(item.id, 1)">
                            {{ item.name }}
                          </v-list-item-title>
                        </template>
                        <div
                          v-for="(itemL1) in item.children"
                          :key="`prof-L-${itemL1.id}`"
                        >
                          <v-list-item
                            v-if="!itemL1.children"
                            class="single_item"
                            link
                            @click="searchCategory(itemL1.id, 1)"
                          >
                            <span>-</span> {{ itemL1.name }}
                          </v-list-item>
                          <v-list-group
                            v-else
                            :value="false"
                            no-action
                            sub-group
                          >
                            <template v-slot:activator>
                              <v-list-item-title @click="searchCategory(itemL1.id, 1)">
                                {{ itemL1.name }}
                              </v-list-item-title>
                            </template>
                            <v-list-item
                              v-for="(itemL2, index) in itemL1.children"
                              :key="`prof-L2-${index}`"
                              class="single_item"
                              link
                              @click="searchCategory(itemL2.id, 1)"
                            >
                              <span>-</span> {{ itemL2.name }}
                            </v-list-item>
                            <v-divider></v-divider>
                          </v-list-group>
                        </div>
                        <v-divider></v-divider>
                      </v-list-group>
                    </div>
                  </div>
                </template>
                <v-divider></v-divider>
                <v-list-item
                  class="single_item"
                  :class="{ 'active': categorySelected === '' }"
                  @click="searchCategory(-1, 1)"
                >
                  - All
                </v-list-item>
              </v-list-group>
            </v-list>
          </template>

          <div
            v-if="active && !$vuetify.breakpoint.mdAndDown"
            class="inner-wrapper-menu"
          >
            <ul
              v-if="!content_type || content_type === -1"
              class="list-menu clearfix"
            >
              <li
                v-for="(item) in categories"
                :key="`system-${item.id}`"
              >
                <v-btn
                  :class="rootCategoryClasses(item.id)"
                  @click="searchCategory(item.id, 1)"
                >
                  {{ item.name }}
                  <v-icon
                    v-if="item.children"
                    :class="{'alternate-icon-small': !mdiChevronDown}"
                    class="mx-auto"
                  >
                    {{ mdiChevronDown }}
                  </v-icon>
                </v-btn>
                <ul v-if="item.children">
                  <li
                    v-for="(itemL1) in item.children"
                    :key="`system-L-${itemL1.id}`"
                  >
                    <span @click="searchCategory(itemL1.id, 1)">
                      {{ itemL1.name }}
                      <v-icon
                        v-if="itemL1.children"
                        :class="{'alternate-icon-small': mdiChevronDown}"
                        class="mx-auto arrow-icon"
                      >
                        {{ mdiChevronDown }}
                      </v-icon>
                    </span>
                    <ul v-if="itemL1.children">
                      <li
                        v-for="(itemL2, index) in itemL1.children"
                        :key="`system-L2-${index}`"
                      >
                        <span @click="searchCategory(itemL2.id, 1)">{{ itemL2.name }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <v-btn
                  :class="{ 'active': categorySelected === '' }"
                  elevation="2"
                  @click="searchCategory(-1, 1)"
                >
                  All
                </v-btn>
              </li>
            </ul>

            <ul
              v-if="content_type || content_type === -1"
              class="list-menu clearfix"
            >
              <li
                v-for="(item) in professionalCategories"
                :key="`prof-${item.id}`"
              >
                <v-btn
                  :class="rootCategoryClasses(item.id)"
                  @click="searchCategory(item.id, 1)"
                >
                  {{ item.name }}
                  <v-icon
                    v-if="item.children"
                    :class="{'alternate-icon-small': !mdiChevronDown}"
                    class="mx-auto"
                  >
                    {{ mdiChevronDown }}
                  </v-icon>
                </v-btn>
                <ul v-if="item.children">
                  <li
                    v-for="(itemL1) in item.children"
                    :key="`prof-L-${itemL1.id}`"
                  >
                    <span @click="searchCategory(itemL1.id, 1)">
                      {{ itemL1.name }}
                      <v-icon
                        v-if="itemL1.children"
                        :class="{'alternate-icon-small': mdiChevronDown}"
                        class="mx-auto arrow-icon"
                      >
                        {{ mdiChevronDown }}
                      </v-icon>
                    </span>
                    <ul v-if="itemL1.children">
                      <li
                        v-for="(itemL2, index) in itemL1.children"
                        :key="`prof-L2-${index}`"
                      >
                        <span @click="searchCategory(itemL2.id, 1)">{{ itemL2.name }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <v-btn
                  :class="{ 'active': categorySelected === '' }"
                  elevation="2"
                  @click="searchCategory(-1, 1)"
                >
                  All
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
      </v-row>

      <v-row
        justify="center"
        class="mt-10 mb-6 position-relative"
      >
        <v-container>
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              class="text-subtitle-1 text-center wrapper-content"
              cols="12"
            >
              <v-timeline v-if="active && files.length">
                <v-timeline-item
                  v-for="(file, i) in files"
                  :key="`biography-${i}`"
                  large
                >
                  <template
                    v-if="!$vuetify.breakpoint.mdAndDown"
                    v-slot:icon
                  >
                    <span class="date-item">{{ formatDate(file.updated_at.split('T')[0]) }}</span>
                    <v-icon
                      :class="{'alternate-icon-small': !mdiBookOpenVariant}"
                      class="mx-auto icon-info-date"
                      dark
                    >
                      {{ mdiBookOpenVariant }}
                    </v-icon>
                  </template>
                  <template v-slot:opposite>
                    <div class="v-timeline-item__body box-slider">
                      <v-card
                        class="elevation-2 cursor-pointer"
                        @click="showModal(file)"
                      >
                        <div v-if="file.view_type && file.related_files.length > 1">
                          <template v-if="isImage(file.related_files[0])">
                            <img
                              :src="`${file.related_files[0]}`"
                              :class="`rotate_images__position_${file.rotate_position ? file.rotate_position[0] : 0}`"
                              @error="onImgError(file.related_files[0])"
                            />
                          </template>
                          <template v-else-if="isVideo(file.related_files[0])">
                            <ListVideo
                              @click.stop
                              playsinline
                              preload="metadata"
                              :poster="videoPosterUrl(file.related_files[0], file)"
                              width="100%"
                              height="100%"
                              controls
                            >
                              <source
                                :src="videoPreviewUrl(file.related_files[0])"
                                :type="getVideoType(file.related_files[0])"
                              >
                              Your browser does not support the video tag.
                            </ListVideo>
                          </template>
                        </div>
                        <div v-else>
                          <v-carousel
                            v-if="file.related_files.length > 1"
                            height="100%"
                          >
                            <v-carousel-item
                              v-for="(item, ic) in file.related_files"
                              :key="ic"
                            >
                              <template v-if="isImage(item)">
                                <img
                                  :src="`${item}`"
                                  :class="`rotate_images__position_${file.rotate_position ? file.rotate_position[ic] : 0}`"
                                  @error="onImgError(item)"
                                />
                              </template>
                              <template v-else-if="isVideo(item)">
                                <ListVideo
                                  @click.stop
                                  playsinline
                                  preload="metadata"
                                  :poster="videoPosterUrl(item, file)"
                                  width="100%"
                                  height="100%"
                                  controls
                                >
                                  <source
                                    :src="videoPreviewUrl(item)"
                                    :type="getVideoType(item)"
                                  >
                                  Your browser does not support the video tag.
                                </ListVideo>
                              </template>
                            </v-carousel-item>
                          </v-carousel>
                          <div v-else>
                            <template v-if="isImage(file.related_files[0])">
                              <img
                                :src="`${file.related_files[0]}`"
                                :class="`rotate_images__position_${file.rotate_position ? file.rotate_position[0] : 0}`"
                                @error="onImgError(file.related_files[0])"
                              />
                            </template>
                            <template v-else-if="isVideo(file.related_files[0])">
                              <ListVideo
                                @click.stop
                                playsinline
                                preload="metadata"
                                :poster="videoPosterUrl(file.related_files[0], file)"
                                width="100%"
                                height="100%"
                                controls
                              >
                                <source
                                  :src="videoPreviewUrl(file.related_files[0])"
                                  :type="getVideoType(file.related_files[0])"
                                >
                                Your browser does not support the video tag.
                              </ListVideo>
                            </template>
                          </div>
                        </div>

                        <v-card-text
                          v-if="$vuetify.breakpoint.mdAndDown"
                          class="item-description"
                        >
                          <div class="wrapper-text">
                            <div class="v-card__title">
                              {{ file.name }}
                            </div>
                            <div>
                              <hr
                                role="separator"
                                aria-orientation="horizontal"
                                class="v-divider theme--light"
                              >
                              <div
                                class="v-card__text"
                                v-html="subString(file.alternative_text)"
                              ></div>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </template>
                  <v-card
                    v-if="!$vuetify.breakpoint.mdAndDown"
                    class="elevation-2 cursor-pointer"
                    @click="showModal(file)"
                  >
                    <v-card-text class="item-description">
                      <div class="wrapper-text">
                        <div class="v-card__title">
                          {{ file.name }}
                        </div>
                        <div>
                          <hr
                            role="separator"
                            aria-orientation="horizontal"
                            class="v-divider theme--light"
                          >
                          <div
                            class="v-card__text"
                            v-html="subString(file.alternative_text)"
                          ></div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>

              <v-container
                v-if="!files.length"
                style="height: 200px;"
              >
                <v-row
                  class="fill-height"
                  align-content="center"
                  justify="center"
                >
                  <v-col
                    v-if="!loading && !loadError"
                    class="text-subtitle-1 text-center"
                    cols="12"
                  >
                    There are no content to show.
                  </v-col>
                  <v-col
                    v-if="loadError && !loading"
                    class="text-center"
                    cols="12"
                  >
                    <p>We couldn't load these entries. Please try again.</p>
                    <v-btn
                      color="primary"
                      @click="getFiles()"
                    >
                      Retry
                    </v-btn>
                  </v-col>
                  <v-progress-circular
                    v-if="loading"
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-row>
              </v-container>

              <a
                v-if="active && files.length"
                href="javascript:;"
                class="show-all-years"
                @click="searchCategory(-1, 1);"
              >Show All</a>
              <ul
                v-if="active && files.length"
                class="lst-timeline"
              >
                <li
                  v-for="(year, iy) in Object.keys(timeline)"
                  :key="iy"
                >
                  <a
                    href="javascript:;"
                    :class="{'active': year === activeYear}"
                    @click="filterByYear(year);"
                  >
                    {{ year }}
                    <v-icon class="mx-auto">{{ mdiChevronDown }}</v-icon>
                  </a>
                  <ul :class="{'active': year === activeYear}">
                    <li
                      v-for="(month, im) in timeline[year]"
                      :key="im"
                    >
                      <a
                        :class="{'active': month === activeMonth}"
                        href="javascript:;"
                        @click="filterByMonth(year, month)"
                      >-{{ months[parseInt(month, 10)-1] }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>
        <div
          v-if="active && files.length"
          class="pagination"
        >
          <span>{{ this.pagination }} of {{ this.qtdPages }} pages</span>
          <v-btn
            v-if="!loading && pagination < qtdPages"
            :key="pagination"
            v-intersect="{ handler: onLoadMoreIntersect, options: { rootMargin: '400px 0px' } }"
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="getNextPage()"
          >
            Load more
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>{{ mdiCached }}</v-icon>
              </span>
            </template>
          </v-btn>
        </div>

        <v-btn
          v-if="active && files.length"
          color="primary"
          class="btn-up"
          dark
          fab
          @click="goTop()"
        >
          <v-icon>
            {{ mdiArrowUpBold }}
          </v-icon>
        </v-btn>
      </v-row>
    </v-container>

    <PublicRecordDialog
      v-model="modalOpen"
      :record="selectedFile"
      :liked="!!(selectedFile && likeStatus[selectedFile.id])"
      :like-count="Number(selectedFile && likeCounts[selectedFile.id]) || 0"
      :owner-name="profileName"
      :owner-avatar="profileAvatar ? `https://self-biography-system.s3.us-east-2.amazonaws.com/${profileAvatar}` : ''"
      @like="toggleLike"
    />

    <LikersDialog
      v-model="likersDialogOpen"
      :file-id="likersDialogFileId"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { Intersect } from 'vuetify/lib/directives'
import {
  mdiChevronDown, mdiCached, mdiArrowUpBold, mdiBookOpenVariant, mdiAccountTie, mdiAccount, mdiAccountMultiple,
  mdiHeartOutline, mdiHeart, mdiClose, mdiCommentOutline, mdiAccountCircle,
} from '@mdi/js'
import videoPreviewUrl, { videoPosterUrl } from '@/utils/videoPreview'
import ListVideo from '@/components/ListVideo.vue'
import PublicProfileHeader from '@/components/PublicProfileHeader.vue'
import LikersDialog from '@/components/LikersDialog.vue'
import PublicRecordDialog from '@/components/PublicRecordDialog.vue'

import { enabled } from '../../../utils/recordPrivacy'

export default {
  name: 'PublicBiography',
  directives: { Intersect },
  components: {
    ListVideo,
    PublicProfileHeader,
    LikersDialog,
    PublicRecordDialog,
  },
  data: () => ({
    /* Icons */
    mdiChevronDown,
    mdiAccountTie,
    mdiAccount,
    mdiAccountMultiple,
    mdiCached,
    mdiArrowUpBold,
    mdiBookOpenVariant,
    mdiHeartOutline,
    mdiHeart,
    mdiClose,
    mdiCommentOutline,
    mdiAccountCircle,

    /* ---- */
    activeYear: null,
    activeMonth: null,
    active: 1,
    pagination: 1,
    qtdPages: 1,
    limitItems: 10,
    endpoint: process.env.VUE_APP_ROOT_API,
    categories: [],
    professionalCategories: [],
    files: [],
    allFiles: [],
    categorySelected: '',
    loading: true,
    loadError: false,
    content_type: 0,
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    timeline: [],
    active_menu_categories: [],
    failedImages: {},
    likeStatus: {},
    likeCounts: {},
    likersDialogOpen: false,
    likersDialogFileId: null,
    modalOpen: false,
    selectedFile: null,
    modalCommentCount: 0,
    profileName: '',
    profileAvatar: '',
  }),
  computed: {
    username() {
      return this.$route.params.username
    },
  },
  mounted() {
    this.initializeFiltersFromRoute()
    this.loadData()
  },
  methods: {
    videoPreviewUrl,
    videoPosterUrl,
    initializeFiltersFromRoute() {
      const queryContentType = Number.parseInt(this.$route.query.ct, 10)
      if (Number.isInteger(queryContentType)) {
        this.content_type = queryContentType
      } else {
        const storedType = Number.parseInt(localStorage.getItem('sb-shared-content-type'), 10)
        this.content_type = Number.isInteger(storedType) && [0, 1, -1].includes(storedType) ? storedType : 0
      }
      this.categorySelected = this.$route.query.cat || ''
      localStorage.setItem('sb-shared-content-type', String(this.content_type))
    },
    syncFiltersToRoute() {
      const nextQuery = { ...this.$route.query }
      localStorage.setItem('sb-shared-content-type', String(this.content_type))

      if (this.content_type === 0) {
        delete nextQuery.ct
      } else {
        nextQuery.ct = String(this.content_type)
      }

      if (this.categorySelected) {
        nextQuery.cat = String(this.categorySelected)
      } else {
        delete nextQuery.cat
      }

      const sameContentType = String(this.$route.query.ct || '') === String(nextQuery.ct || '')
      const sameCategory = String(this.$route.query.cat || '') === String(nextQuery.cat || '')
      if (!sameContentType || !sameCategory) {
        this.$router.replace({ query: nextQuery })
      }
    },
    findRootCategoryId(categories, targetId) {
      for (const category of categories) {
        if (Number(category.id) === Number(targetId)) return Number(category.id)
        if (category.children && category.children.length) {
          const nestedMatch = this.findRootCategoryId(category.children, targetId)
          if (nestedMatch !== null) return Number(category.id)
        }
      }

      return null
    },
    getSelectedRootCategoryId() {
      if (!this.categorySelected) return null
      const selectedId = Number(this.categorySelected)
      const personalMatch = this.findRootCategoryId(this.categories, selectedId)
      if (personalMatch !== null) return personalMatch

      return this.findRootCategoryId(this.professionalCategories, selectedId)
    },
    rootCategoryClasses(categoryId) {
      return {
        'root-category-active': Number(categoryId) === this.getSelectedRootCategoryId(),
      }
    },
    isImage(filePath) {
      if (!filePath) return false
      try {
        const pathname = new URL(filePath).pathname
        const ext = pathname.split('.').pop().toLowerCase()
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
        const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
        if (imageExtensions.includes(ext)) return true
        if (videoExtensions.includes(ext)) return false
      } catch {
        // fallback
      }

      return !this.failedImages[filePath]
    },
    isVideo(filePath) {
      if (!filePath) return false
      try {
        const pathname = new URL(filePath).pathname
        const ext = pathname.split('.').pop().toLowerCase()
        const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
        if (videoExtensions.includes(ext)) return true
      } catch {
        // fallback
      }

      return !!this.failedImages[filePath]
    },
    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },
    getVideoType(filePath) {
      let ext = 'mp4'
      try {
        const pathname = new URL(filePath).pathname
        ext = pathname.split('.').pop().toLowerCase()
      } catch {
        ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      }
      const types = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        avi: 'video/avi',
        mov: 'video/quicktime',
        mkv: 'video/x-matroska',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
      }

      return types[ext] || 'video/mp4'
    },
    goTop() {
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
    },
    formatDate(date) {
      if (!date) return null
      const [year, month] = date.split('-')

      return `${this.months[parseInt(month, 10) - 1]} ${year}`
    },
    checkContentType(val) {
      this.content_type = val
      this.searchCategory(-1, 1)
    },
    async loadData() {
      this.loading = true
      await this.getProfileInfo()
      await this.getCategories()
      await this.getFiles()
    },
    async getProfileInfo() {
      try {
        const response = await axios.get(
          `${this.endpoint}/getPublicUser?username=${encodeURIComponent(this.username)}`,
        )
        if (response.data.content && response.data.content.length) {
          this.profileName = response.data.content[0].name || ''
          this.profileAvatar = response.data.content[0].avatar || ''
        }
      } catch {
        // Silently fail
      }
    },
    showModal(file) {
      this.selectedFile = file
      this.modalCommentCount = 0
      this.modalOpen = true
    },
    searchCategory(value, page) {
      this.categorySelected = value !== -1 ? value : ''
      this.pagination = page
      this.timeline = []
      this.syncFiltersToRoute()
      this.applyFilters()
    },
    async getCategories() {
      try {
        const response = await axios.get(
          `${this.endpoint}/getPublicCategories?username=${encodeURIComponent(this.username)}`,
        )
        this.categories = []
        this.professionalCategories = []
        this.active_menu_categories = response.data.active_menu_categories || []
        if (response.data.content) {
          response.data.content.forEach(value => {
            if (value.type) {
              if (!value.content_type) {
                if (value.active) {
                  this.categories.push(value)
                }
              } else {
                if (value.active) {
                  this.professionalCategories.push(value)
                }
              }
            }
          })
        }
      } catch {
        // Categories loading failed silently
      }
    },
    async getFiles() {
      this.allFiles = []
      this.loadError = false
      this.applyFilters()
      this.loading = true
      try {
        const response = await axios.get(
          `${this.endpoint}/getPublicItems?username=${encodeURIComponent(this.username)}`,
        )
        if (!response.data || response.data.error || !Array.isArray(response.data.content)) throw new Error('Invalid public entries response')
        if (response.data.content) {
          this.allFiles = response.data.content.filter(item => enabled(item.public) && enabled(item.effective_public)).map(item => {
            if (item.rotate_position) {
              item.rotate_position = typeof item.rotate_position === 'string' ? item.rotate_position.split(', ') : item.rotate_position
            } else {
              item.rotate_position = []
            }
            if (!item.related_files) {
              item.related_files = []
            }

            return item
          })
          this.applyFilters()
          this.fetchLikeData(this.allFiles.map(f => f.id))
        }
      } catch {
        this.loadError = true
      }
      this.loading = false
    },
    applyFilters() {
      let filtered = this.allFiles.filter(item => enabled(item.public) && enabled(item.effective_public))

      // Filter by content_type
      if (this.content_type === 0) {
        filtered = filtered.filter(f => !f.content_type || f.content_type === 0)
      } else if (this.content_type === 1) {
        filtered = filtered.filter(f => f.content_type === 1)
      }
      // content_type === -1 means "both", no filtering

      // Filter by category
      if (this.categorySelected) {
        filtered = filtered.filter(f => {
          if (!f.categories) return false
          const cats = String(f.categories).split(', ').map(Number)

          return cats.includes(Number(this.categorySelected))
        })
      }

      // Filter by year/month
      if (this.activeYear) {
        filtered = filtered.filter(f => {
          const dateStr = f.updated_at ? f.updated_at.split('T')[0] : ''

          return dateStr.startsWith(this.activeYear)
        })
        if (this.activeMonth) {
          filtered = filtered.filter(f => {
            const dateStr = f.updated_at ? f.updated_at.split('T')[0] : ''
            const monthPart = dateStr.split('-')[1]

            return monthPart === this.activeMonth
          })
        }
      }

      // Oldest memory dates first, before pagination.
      filtered.sort((a, b) => (Date.parse(a.updated_at) || 0) - (Date.parse(b.updated_at) || 0) || Number(a.id) - Number(b.id))

      // Build timeline
      this.timeline = []
      filtered.forEach(value => {
        if (!value.updated_at) return
        const yearC = value.updated_at.split('T')[0].split('-')[0]
        const monthC = value.updated_at.split('T')[0].split('-')[1]
        if (this.timeline[yearC]) {
          if (!this.timeline[yearC].includes(monthC)) {
            this.timeline[yearC].push(monthC)
          }
        } else {
          this.timeline[yearC] = []
          this.timeline[yearC].push(monthC)
        }
      })

      // Pagination
      this.qtdPages = Math.ceil(filtered.length / this.limitItems)
      const start = 0
      const end = this.pagination * this.limitItems
      this.files = filtered.slice(start, end)
    },
    filterByYear(year) {
      this.pagination = 1
      this.$set(this, 'activeYear', year)
      this.$set(this, 'activeMonth', null)
      this.applyFilters()
    },
    filterByMonth(year, month) {
      this.pagination = 1
      this.$set(this, 'activeYear', year)
      this.$set(this, 'activeMonth', month)
      this.applyFilters()
    },
    onLoadMoreIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) this.getNextPage()
    },
    getNextPage() {
      if (this.loading || this.pagination >= this.qtdPages) return
      this.pagination++
      this.applyFilters()
    },
    subString(value) {
      if (value !== undefined) {
        return `${value.substring(0, 540)}...`
      }

      return value
    },
    async fetchLikeData(fileIds) {
      if (!fileIds || !fileIds.length) return
      try {
        const token = this.$store.state.jwtToken
        if (token) {
          const response = await axios.get(
            `${this.endpoint}/getLikeStatus?file_ids=${fileIds.join(',')}`,
            { headers: { Authorization: token } },
          )
          if (response.data) {
            this.likeStatus = { ...this.likeStatus, ...response.data.likeStatus }
            this.likeCounts = { ...this.likeCounts, ...response.data.likeCounts }
          }
        } else {
          for (const id of fileIds) {
            try {
              const response = await axios.get(`${this.endpoint}/getLikes?file_id=${id}`)
              if (response.data) {
                this.$set(this.likeCounts, id, response.data.likeCount || 0)
              }
            } catch {
              // skip
            }
          }
        }
      } catch {
        // Silently fail
      }
    },
    async toggleLike(file) {
      if (!this.$store.state.jwtToken) return
      try {
        const response = await axios.post(`${this.endpoint}/toggleLike`, {
          file_id: file.id,
        }, {
          headers: { Authorization: this.$store.state.jwtToken },
        })
        if (response.data) {
          this.$set(this.likeStatus, file.id, response.data.liked)
          this.$set(this.likeCounts, file.id, response.data.likeCount)
        }
      } catch {
        // Silently fail
      }
    },
    openLikersDialog(fileId) {
      this.likersDialogFileId = fileId
      this.likersDialogOpen = true
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper-menu {
  flex: 1;
  position: relative;
  .inner-wrapper-menu {
    text-align: center;
  }
  .v-btn {
    margin-bottom: 20px;
  }

  .v-btn:not(:last-child) {
    margin-right: 10px;
  }
}

.v-window.v-item-group.theme--dark.v-carousel img {
  width: 100%;
  height: auto;
  padding: 17px;
}

.date-item {
  width: 200%;
  display: block;
  position: absolute;
  top: -15%;
  z-index: 1;
}

.root-category-active {
  background-color: #9155fd !important;
  border-color: #9155fd !important;
  color: #fff !important;
}

.v-timeline {
  border-top: 1px solid #ccc;
  &::before {
    display: none !important;
  }
}

.v-timeline-item {
  position: relative;
  padding: 80px 0 60px;
  border-bottom: 1px solid #ccc;

  img {
    width: 100%;
    height: auto;
    border-radius: 12px;
  }

  &:nth-child(odd) {
    .box-slider {
      .v-card:before,
      .v-card:after {
        transform: rotate(180deg) !important;
        right: -10px !important;
        left: initial !important;
      }
    }
  }
  &:nth-child(even) {
    .box-slider {
      .v-card:before,
      .v-card:after {
        transform: rotate(0deg) !important;
        right: initial !important;
        left: -10px !important;
      }
    }
  }
}

.wrapper-text {
  text-align: left;
}

@media (min-width: 1264px) {
  .v-timeline-item__body .v-card {
    min-height: 351px;
  }
}

@media (min-width: 1904px) {
  .v-timeline-item__body .v-card {
    min-height: 415px;
  }
}

.box-slider {
  img {
    width: fit-content !important;
    height: fit-content !important;
    display: block;
    max-width: 100%;
    padding: 17px !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    cursor: pointer;
    max-height: 383px;
    border-radius: 8px;
  }
}

@media(max-width: 940px) {
  .v-timeline-item__divider {
    display: none !important;
  }

  .box-slider {
    img {
      position: static;
    }
  }
}

.list-menu {
  margin: 0 0px !important;
  padding: 0 !important;
  justify-content: center !important;
  display: flex !important;
  li {
    text-align: left;
    list-style: none;
    cursor: pointer;
    position: relative;
    margin: 10px 0;
    ul {
      display: none;
      position: absolute;
      left: 0;
      width: auto;
      max-width: 300px;
      background: #fff;
      box-shadow: 0 4px 8px -4px rgb(94 86 105 / 42%);
      padding: 0;
      border-radius: 6px;
      top: 70%;
      z-index: 5;

      color:rgba(94, 86, 105, 0.87);
      text-transform: uppercase;
      font-size: 0.875rem;
      font-family: Inter, sans-serif;
      font-weight: 500;

      li {
        padding: 0 20px 0 15px;
        display: block;
        min-width: 150px;
        span {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .arrow-icon {
        transform: rotate(-90deg);
        position: absolute;
        right: -2px;
      }

      ul {
        left: 100%;
        top: -10px;
      }
    }
    &:hover {
      text-decoration: underline;
      > ul {
        display: block;
      }
    }
  }
  > li {
    float: left;
    margin: 0;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.wrapper-content {
  position: relative;
}

/* Component */
.lst-timeline  {
  position: fixed;
  top: 335px;
  right: calc(((100vw - 1392px) - 250px) / 2);
  z-index: 5;
  margin: 0;
  overflow: hidden;
  overflow-y: auto;
  max-height: calc(100vh - 815px);

  > li {
    list-style: none;
    width: 100px;
    padding: 10px 0 10px 20px;
    margin: 0;
    text-align: center;
    font-size: 14px;

    .v-icon {
      transform: scale(0.8) translate(-4px, -2px)  rotate(0deg);
    }

    &:first-child {
      padding-top: 0;
    }

    a {
      transition: all 0.2s ease;
      position: relative;
      color: rgba(94, 86, 105, 0.68);
      text-decoration: none;
      font-weight: 500;
      &:hover {
        padding-left: 15px;
        color: #9155fd;
      }
      &.active {
        color: #9155fd;
        font-weight: bold;
        .v-icon {
          transform: scale(0.8) translate(-4px, -2px) rotate(180deg);
          color: #9155fd;
        }
      }
    }

    ul {
      margin: 0;
      padding-left: 10px;
      transition: all 0.3s ease-out;
      height: 0;
      overflow: hidden;

      &.active {
        height: auto;
        margin: 5px 0;
      }
    }

    li {
      list-style: none;
      padding: 0;
    }
  }
}

.show-all-years {
  position: fixed;
  top: 285px;
  right: calc(((100vw - 1392px) - 250px) / 2);
  margin: 0;
  width: 100px;
  text-align: center;
  padding: 0 0 5px 0;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  color:rgba(94, 86, 105, 0.68);
  text-decoration: none;
  z-index: 2;
  &:hover {
    color: #9155fd;
  }
}

.pagination {
  span {
    display: block;
    text-align: center;
    margin-bottom: 20px;
  }
}

.btn-up {
  position: absolute;
  right: 11px;
  bottom: 0px;
}

.like-row {
  .like-count {
    font-size: 13px;
    margin-left: 4px;
    font-weight: 500;
  }
}

.cursor-pointer {
  cursor: pointer;
}

.modal-img {
  width: 100%;
  height: auto;
  max-height: 60vh;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
}

.like-action,
.comment-action {
  .like-count {
    font-size: 13px;
    font-weight: 500;
  }
}
</style>
